const urlUtils = {
    removeErrorParamCheckout: function (step) {
        let url = new URL(window.location.href);
        if (url.search.indexOf('error=') !== -1) {
            window.history.pushState({}, document.title, window.location.href.split('?')[0] + `?step=${step}`);
        }
    }
};
export default urlUtils;
